var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_2614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.019 4.97725C22.3791 -1.66065 11.6153 -1.65906 4.97737 4.9809C-1.66053 11.6209 -1.65894 22.3847 4.98103 29.0226C11.621 35.6605 22.3848 35.6589 29.0227 29.0189C32.2106 25.83 34.001 21.5053 34 16.9963C33.9991 12.4879 32.2074 8.16462 29.019 4.97725ZM25.7459 23.6807C25.7452 23.6814 25.7445 23.6822 25.7437 23.683V23.6773L24.8823 24.533C23.7683 25.661 22.146 26.1251 20.604 25.757C19.0504 25.3411 17.5735 24.6792 16.2293 23.7963C14.9805 22.9982 13.8231 22.0652 12.7783 21.014C11.817 20.0596 10.9533 19.0117 10.2 17.886C9.37599 16.6746 8.72381 15.355 8.26196 13.9646C7.7325 12.3313 8.17125 10.539 9.39531 9.33496L10.404 8.32632C10.6844 8.04462 11.1401 8.04362 11.4217 8.32406C11.4224 8.32479 11.4232 8.32552 11.424 8.32632L14.6086 11.511C14.8903 11.7914 14.8913 12.2471 14.6109 12.5287C14.6101 12.5294 14.6094 12.5302 14.6086 12.531L12.7386 14.401C12.202 14.9317 12.1346 15.775 12.58 16.3843C13.2563 17.3125 14.0048 18.186 14.8183 18.9967C15.7254 19.9076 16.7114 20.7363 17.765 21.473C18.3737 21.8976 19.199 21.826 19.7256 21.303L21.5332 19.467C21.8137 19.1853 22.2694 19.1843 22.551 19.4648C22.5517 19.4655 22.5525 19.4662 22.5532 19.467L25.7436 22.663C26.0254 22.9434 26.0264 23.399 25.7459 23.6807Z",
    fill: "#E0AF04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_2614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5c2b9ee2197d454a62a82b3f7f43d1fb.svg";
export { ForwardRef as ReactComponent };